import React from "react";

const TitlePlansMobile = (): React.JSX.Element => {
  return (
    <div className="mt-20 flex w-full flex-col items-center justify-center">
      <div className="flex">
        <p className="flex bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text font-bold text-4xl text-transparent">
          Compare <span className="flex text-white-100">&nbsp; Plans </span>
        </p>
      </div>
    </div>
  );
};

export default TitlePlansMobile;
